export default "__VITE_ASSET__d22ee661__"